module.exports = __webpack_public_path__ + "static/media/Tour24_IDVerification_TermsofUse_2022.42f15c4d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pdfs/Tour24_IDVerification_TermsofUse_2022.pdf
// module id = 1720
// module chunks = 0